module.exports = __webpack_public_path__ + "494cd07c/img/ion_calendar-number.3ac5bd07.svg";